export default __webpack_public_path__ + "static/media/p41.44caba30.jpg";